import React from 'react';

const Insights = () => {
  const blogs = [
    {
      title: 'The Future of AI in Enterprise',
      date: 'April 26, 2025',
      category: 'Artificial Intelligence',
      image: 'https://via.placeholder.com/400x250',
      excerpt: 'Exploring how AI is transforming enterprise operations and decision-making processes.'
    },
    {
      title: 'Machine Learning Best Practices',
      date: 'April 25, 2025',
      category: 'Machine Learning',
      image: 'https://via.placeholder.com/400x250',
      excerpt: 'Key considerations and best practices for implementing machine learning solutions.'
    },
    {
      title: 'Data Privacy in the Digital Age',
      date: 'April 24, 2025',
      category: 'Security',
      image: 'https://via.placeholder.com/400x250',
      excerpt: 'Understanding the importance of data privacy and protection in modern applications.'
    }
  ];

  const whitepapers = [
    {
      title: 'Cognitive Computing: A Comprehensive Guide',
      description: 'In-depth analysis of cognitive computing technologies and applications',
      downloadLink: '#'
    },
    {
      title: 'AI Implementation Strategies',
      description: 'Strategic approaches to implementing AI in enterprise environments',
      downloadLink: '#'
    }
  ];

  return (
    <div className="container mt-4">
      {/* Hero Section */}
      <div className="text-center mb-5">
        <h1 className="display-4 mb-3">Insights & Resources</h1>
        <p className="lead text-muted">
          Stay updated with the latest trends and insights in cognitive computing
        </p>
      </div>

      {/* Blog Posts */}
      <h2 className="mb-4">Latest Blog Posts</h2>
      <div className="row g-4 mb-5">
        {blogs.map((blog, index) => (
          <div key={index} className="col-md-4">
            <div className="card h-100 shadow-sm">
              <img src={blog.image} className="card-img-top" alt={blog.title} />
              <div className="card-body">
                <div className="d-flex justify-content-between mb-2">
                  <small className="text-muted">{blog.date}</small>
                  <span className="badge bg-primary">{blog.category}</span>
                </div>
                <h3 className="h5 card-title">{blog.title}</h3>
                <p className="card-text">{blog.excerpt}</p>
                <button className="btn btn-outline-primary">Read More</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Whitepapers Section */}
      <div className="bg-light p-4 rounded mb-5">
        <h2 className="mb-4">Whitepapers</h2>
        <div className="row g-4">
          {whitepapers.map((whitepaper, index) => (
            <div key={index} className="col-md-6">
              <div className="card h-100">
                <div className="card-body">
                  <h3 className="h5 card-title">{whitepaper.title}</h3>
                  <p className="card-text">{whitepaper.description}</p>
                  <a href={whitepaper.downloadLink} className="btn btn-outline-dark">
                    <i className="fas fa-download me-2"></i>Download
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter Signup */}
      <div className="text-center p-5 bg-primary text-white rounded">
        <h2 className="mb-4">Stay Updated</h2>
        <p className="lead mb-4">Subscribe to our newsletter for the latest insights and updates</p>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="input-group mb-3">
              <input type="email" className="form-control" placeholder="Enter your email" />
              <button className="btn btn-light" type="button">Subscribe</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;